/* eslint class-methods-use-this: 0 */
import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import _ from 'underscore';
import SelectReasonCodes from 'components/modules/marketplace-config/SelectReasonCodes';
import { withTranslation } from 'react-i18next';

const cancelReasons = [
  { value: 'Duplicate', name: 'Duplicate' },
  { value: 'Missed Pickup', name: 'Missed Pickup' },
  { value: 'Re-Schedule', name: 'Re-Schedule' },
  { value: 'Carrier Mistake', name: 'Carrier Mistake' },
  { value: 'Shipper Request', name: 'Shipper Request' },
  { value: 'Will Not Reexpose', name: 'Will Not Reexpose' },
];

class CancelShipmentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: null,
      comment: '',
      commentRequired: false,
    };
  }

  onCancelShipment() {
    this.props.onCancelShipment(
      this.props.shipment,
      this.state.reason,
      this.state.comment,
    );
    this.setState({ reason: null, comment: '', commentRequired: false }, () => {
      this.props.onHide();
    });
  }

  handleReasonSelect = (item) => {
    this.setState({ reason: item });
  };

  handleCommentInput = (comment) => {
    this.setState({ comment });
  };

  handleCommentRequired = (value) => {
    this.setState({ commentRequired: value });
  };

  render() {
    if (!this.props.shipment) return null;
    const { commentRequired, comment } = this.state;
    const commentMissing = commentRequired && !comment.length;
    const { t } = this.props;

    return (
      <Modal show={this.props.show} onHide={() => this.props.onHide()} enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{`${t('CANCEL_SHIPMENT')} - ${
            this.props.shipment.shipment_id
          }`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row style={{ marginBottom: 10 }}>
            <Col xs={12}>{t('CANCEL_SHIPMENT_SPECIFY_REASON')}</Col>
          </Row>
          <Row>
            <Col xs={12}>
              <SelectReasonCodes
                shipment={this.props.shipment}
                category="shipment_cancellation"
                updateComment={this.handleCommentInput}
                selectReasonCode={this.handleReasonSelect}
                updateCommentRequired={this.handleCommentRequired}
                useDescriptionAsValue
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={8} />
            <Col xs={4}>
              <Button
                disabled={
                  !this.state.reason ||
                  _.isEmpty(this.state.reason) ||
                  commentMissing
                }
                onClick={() => this.onCancelShipment()}
                style={{ marginRight: 5 }}
                bsStyle="danger"
              >
                {t('CANCEL_SHIPMENT')}
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(CancelShipmentModal);
